// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"zv","category":"zw","tab":"zx","selected":"zy","isRental":"zz"};